export const SET_MY_TOKEN_BALANCE = 'SET_MY_TOKEN_BALANCE';
export const SET_MY_ETHER_BALANCE = 'SET_MY_ETHER_BALANCE';
export const SET_INPUT_TOKENS_TO_PURCHASE = 'SET_INPUT_TOKENS_TO_PURCHASE';

export const setMyTokensBalance = value => ({
  type: SET_MY_TOKEN_BALANCE,
  payload: value
});

export const setMyEtherBalance = value => ({
  type: SET_MY_ETHER_BALANCE,
  payload: value
});

export const setInputTokensToPurchase = value => ({
  type: SET_INPUT_TOKENS_TO_PURCHASE,
  payload: value
});



// WEBPACK FOOTER //
// ./src/redux/actions/userAccountActions.js